/* Machino fulfillment guard (pickup-only / phantom stock)
   Reads per-variant states from script[data-machino-fulfillment-map] JSON.
   States: ships (default) | pickup_only | sold_out. na:1 = natively unavailable (theme handles).
   Pickup service detection: probes the api-pickup-availability section once per page.
   If local pickup is disabled in Shopify (empty probe response), pickup_only variants
   are treated as sold_out and all pickup UI (notice, pills, cart banner/chips,
   checkout relabel) is suppressed. Probe failure = assume pickup is on (previous behavior). */
(function () {
  'use strict';

  var registry = {};
  var lastState = {};
  var timers = {};

  /* null = unknown (assume on), true = pickup service on, false = off */
  var pickupEnabled = null;
  var probeStarted = false;

  function probePickup(variantId) {
    if (probeStarted || !variantId) return;
    probeStarted = true;
    var root = (window.theme && window.theme.routes && window.theme.routes.root)
      || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      || '/';
    if (root.slice(-1) !== '/') root += '/';
    fetch(root + 'variants/' + variantId + '/?section_id=api-pickup-availability')
      .then(function (r) {
        if (!r.ok) throw new Error('probe failed');
        return r.text();
      })
      .then(function (html) {
        pickupEnabled = html.indexOf('pickup__preview') !== -1;
        Object.keys(registry).forEach(schedule);
        applyCart();
      })
      .catch(function () { /* leave pickupEnabled = null: fail toward previous behavior */ });
  }

  function collectMaps(root) {
    var scripts = (root || document).querySelectorAll('script[data-machino-fulfillment-map]');
    for (var i = 0; i < scripts.length; i++) {
      var el = scripts[i];
      var formId = el.getAttribute('data-mfp-form');
      if (!formId || registry[formId]) continue;
      try {
        var data = JSON.parse(el.textContent);
        data.firstShip = null;
        for (var j = 0; j < data.variants.length; j++) {
          var v = data.variants[j];
          if (v.s === 'ships' && !v.na) { data.firstShip = v; break; }
        }
        registry[formId] = data;
        for (var k = 0; k < data.variants.length; k++) {
          if (data.variants[k].s === 'pickup_only') { probePickup(data.variants[k].id); break; }
        }
        initForm(formId);
      } catch (e) { /* malformed map: fail safe, do nothing */ }
    }
  }

  function optionInputs(formId) {
    return document.querySelectorAll('[data-single-option-selector][form="' + formId + '"]');
  }

  function selectedOptions(formId) {
    var inputs = optionInputs(formId), values = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var idx = parseInt((input.getAttribute('data-index') || '').replace('option', ''), 10) - 1;
      if (isNaN(idx) || idx < 0) continue;
      if (input.type === 'radio') { if (input.checked) values[idx] = input.value; }
      else values[idx] = input.value;
    }
    return values;
  }

  function matchVariant(data, values) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], match = true;
      for (var j = 0; j < v.o.length; j++) {
        if (values[j] !== v.o[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function findVariant(formId) {
    var data = registry[formId];
    if (!data) return null;
    if (data.singleDefault) return data.variants[0] || null;
    return matchVariant(data, selectedOptions(formId));
  }

  function markPills(formId) {
    var data = registry[formId];
    if (!data || data.singleDefault) return;
    var inputs = optionInputs(formId);
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.type !== 'radio') continue;
      var idx = parseInt((input.getAttribute('data-index') || '').replace('option', ''), 10) - 1;
      if (isNaN(idx) || idx < 0) continue;
      var values = selectedOptions(formId).slice();
      values[idx] = input.value;
      var v = matchVariant(data, values);
      var isPickup = !!v && v.s === 'pickup_only' && !v.na;
      var wrap = input.closest('.radio__button');
      if (wrap) wrap.classList.toggle('mfp-pill-pickup', isPickup && pickupEnabled !== false);
      if (v && !v.na) {
        if (v.s === 'sold_out' || (v.s === 'pickup_only' && pickupEnabled === false)) {
          input.classList.add('sold-out');
        }
      }
    }
  }

  function apply(formId) {
    var data = registry[formId];
    if (!data) return;
    var form = document.getElementById(formId);
    if (!form) return;
    var btn = form.querySelector('[data-add-to-cart]');
    var txt = form.querySelector('[data-add-to-cart-text]');
    var notice = document.querySelector('[data-mfp-notice][data-mfp-form="' + formId + '"]');
    var variant = findVariant(formId);
    var state = variant ? (variant.na ? 'native_sold' : variant.s) : 'ships';

    /* Pickup service off: pickup-only stock cannot be fulfilled at all */
    if (state === 'pickup_only' && pickupEnabled === false) state = 'sold_out';

    if (state === 'pickup_only') {
      if (btn && txt) {
        btn.classList.add('mfp-btn-pickup');
        btn.removeAttribute('disabled');
        if (txt.textContent !== 'Reserve for pickup') txt.textContent = 'Reserve for pickup';
      }
      if (notice) {
        var lead = notice.querySelector('[data-mfp-lead]');
        if (lead) {
          var leadText = data.singleDefault ? 'This item is' : 'Size ' + variant.o.join(' / ') + ' is';
          if (lead.textContent !== leadText) lead.textContent = leadText;
        }
        var swap = notice.querySelector('[data-mfp-swap]');
        if (swap) swap.hidden = !data.firstShip;
        notice.hidden = false;
      }
    } else {
      if (notice) notice.hidden = true;
      if (btn && txt) {
        btn.classList.remove('mfp-btn-pickup');
        if (state === 'sold_out') {
          btn.setAttribute('disabled', 'disabled');
          if (txt.textContent !== 'Sold out') txt.textContent = 'Sold out';
        } else if (state === 'ships' && (lastState[formId] === 'pickup_only' || lastState[formId] === 'sold_out')) {
          btn.removeAttribute('disabled');
          var atc = data.atc || 'Add to cart';
          if (txt.textContent !== atc) txt.textContent = atc;
        }
      }
    }
    lastState[formId] = state;
    markPills(formId);
  }

  function schedule(formId) {
    clearTimeout(timers[formId]);
    timers[formId] = setTimeout(function () { apply(formId); }, 30);
  }

  function swapToShip(formId) {
    var data = registry[formId];
    if (!data || !data.firstShip) return;
    var target = data.firstShip;
    var inputs = optionInputs(formId);
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var idx = parseInt((input.getAttribute('data-index') || '').replace('option', ''), 10) - 1;
      if (isNaN(idx) || idx < 0 || idx >= target.o.length) continue;
      if (input.type === 'radio') {
        if (input.value === target.o[idx] && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (input.value !== target.o[idx]) {
        input.value = target.o[idx];
        var popout = input.closest('[data-popout]');
        var toggleText = popout && popout.querySelector('[data-popout-toggle-text]');
        if (toggleText) toggleText.textContent = target.o[idx];
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    schedule(formId);
  }

  function initForm(formId) {
    var data = registry[formId];
    var explicitVariant = /[?&]variant=/.test(location.search);
    var v = findVariant(formId);
    if (!explicitVariant && !data.singleDefault && v && !v.na && v.s !== 'ships' && data.firstShip) {
      swapToShip(formId);
    } else {
      schedule(formId);
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-single-option-selector]')) {
      var formId = t.getAttribute('form');
      if (formId && registry[formId]) schedule(formId);
    }
  });

  document.addEventListener('click', function (e) {
    var swap = e.target && e.target.closest && e.target.closest('[data-mfp-swap]');
    if (!swap) return;
    e.preventDefault();
    var formId = swap.getAttribute('data-mfp-form');
    if (!formId || !registry[formId]) return;
    swapToShip(formId);
    var inputs = optionInputs(formId);
    for (var i = 0; i < inputs.length; i++) {
      var wrap = inputs[i].closest('.radio__button');
      if (wrap && !wrap.classList.contains('mfp-pill-pickup') && !inputs[i].classList.contains('sold-out')) {
        wrap.classList.remove('mfp-flash');
        void wrap.offsetWidth;
        wrap.classList.add('mfp-flash');
      }
    }
  });

  ['theme:variant:change', 'variant:change'].forEach(function (name) {
    document.addEventListener(name, function () {
      Object.keys(registry).forEach(schedule);
    });
  });

  /* Cart: relabel checkout button when the whole order is store pickup.
     When the pickup service is off, hide the banner and chips instead.
     IMPORTANT: writes are guarded on inequality. An unconditional write re-triggers
     the MutationObserver and livelocks the page. */
  function setLabel(el, label) {
    var isInput = el.tagName === 'INPUT';
    var current = isInput ? el.value : el.textContent.trim();
    if (current === label) return;
    if (isInput) el.value = label; else el.textContent = label;
  }

  /* A pickup-only line in the cart: its variant id comes from the remove
     link's data-id (line_item.key = "<variant_id>:<hash>") */
  function cartProbeVariant() {
    var chip = document.querySelector('.mfp-chip');
    var item = chip && chip.closest('[data-item]');
    var remove = item && item.querySelector('[data-item-remove]');
    var key = remove && remove.getAttribute('data-id');
    var vid = key && key.split(':')[0];
    return (vid && /^\d+$/.test(vid)) ? vid : null;
  }

  function applyCart() {
    var banner = document.querySelector('[data-mfp-cart-banner]');
    if (banner && !probeStarted) probePickup(cartProbeVariant());

    var off = pickupEnabled === false;
    if (banner && (banner.style.display === 'none') !== off) {
      banner.style.display = off ? 'none' : '';
    }
    var chips = document.querySelectorAll('.mfp-chip');
    for (var j = 0; j < chips.length; j++) {
      if ((chips[j].style.display === 'none') !== off) {
        chips[j].style.display = off ? 'none' : '';
      }
    }

    var allPickup = !off && !!banner && banner.getAttribute('data-mfp-all-pickup') === 'true';
    var buttons = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var isInput = b.tagName === 'INPUT';
      var current = isInput ? b.value : b.textContent.trim();
      if (!b.hasAttribute('data-mfp-orig') && current !== 'Checkout for store pickup') {
        b.setAttribute('data-mfp-orig', current);
      }
      if (allPickup) {
        setLabel(b, 'Checkout for store pickup');
      } else if (current === 'Checkout for store pickup') {
        setLabel(b, b.getAttribute('data-mfp-orig') || 'Checkout');
      }
    }
  }

  var moScheduled = false;
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        if (moScheduled) return;
        moScheduled = true;
        setTimeout(function () {
          moScheduled = false;
          collectMaps(document);
          applyCart();
        }, 50);
        return;
      }
    }
  });

  function boot() {
    collectMaps(document);
    applyCart();
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
